export default __webpack_public_path__ + "static/media/254-nato.0934c66e.svg";